"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribingClient = exports.NoOpSubscribingClient = void 0;

var _subscribingRequest = require("./subscribing-request");

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * A client which manages entity state and event subscriptions.
 *
 * @abstract
 */
var SubscribingClient = /*#__PURE__*/function () {
  /**
   * @param {!ActorRequestFactory} actorRequestFactory
   *        a request factory to build requests to Spine server
   */
  function SubscribingClient(actorRequestFactory) {
    _classCallCheck(this, SubscribingClient);

    this._requestFactory = actorRequestFactory;
  }
  /**
   * Creates a new subscription request.
   *
   * @param {!Class<Message>} type the target entity type
   * @param {!Client} client the client that initiated the request
   * @return {SubscriptionRequest} a new subscription request
   */


  _createClass(SubscribingClient, [{
    key: "subscribeTo",
    value: function subscribeTo(type, client) {
      return new _subscribingRequest.SubscriptionRequest(type, client, this._requestFactory);
    }
    /**
     * Subscribes to a given topic which targets an entity type.
     *
     * @param {!spine.client.Topic} topic a topic to subscribe to
     * @return {Promise<EntitySubscriptionObject<Message>>} a subscription object
     *
     * @template <T> a Protobuf type of entities being the target of a subscription
     */

  }, {
    key: "subscribe",
    value: function subscribe(topic) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * Creates a new event subscription request.
     *
     * @param {!Class<Message>} type the target event type
     * @param {!Client} client the client that initiated the request
     * @return {EventSubscriptionRequest} a new event subscription request
     */

  }, {
    key: "subscribeToEvent",
    value: function subscribeToEvent(type, client) {
      return new _subscribingRequest.EventSubscriptionRequest(type, client, this._requestFactory);
    }
    /**
     * Subscribes to the given topic which targets an event type.
     *
     * @param {!spine.client.Topic} topic a topic to subscribe to
     * @return {Promise<EventSubscriptionObject>} a subscription object
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(topic) {
      throw new Error('Not implemented in abstract base.');
    }
    /**
     * Returns a new topic factory instance which can be further used for the `Topic` creation.
     *
     * @return {TopicFactory}
     */

  }, {
    key: "newTopic",
    value: function newTopic() {
      return this._requestFactory.topic();
    }
  }]);

  return SubscribingClient;
}();

exports.SubscribingClient = SubscribingClient;
var SUBSCRIPTIONS_NOT_SUPPORTED = 'Subscriptions are not supported.';
/**
 * A {@link SubscribingClient} which does not create subscriptions.
 */

var NoOpSubscribingClient = /*#__PURE__*/function (_SubscribingClient) {
  _inherits(NoOpSubscribingClient, _SubscribingClient);

  var _super = _createSuper(NoOpSubscribingClient);

  function NoOpSubscribingClient(actorRequestFactory) {
    _classCallCheck(this, NoOpSubscribingClient);

    return _super.call(this, actorRequestFactory);
  }
  /**
   * Always throws an error.
   *
   * @override
   */


  _createClass(NoOpSubscribingClient, [{
    key: "subscribe",
    value: function subscribe(topic) {
      throw new Error(SUBSCRIPTIONS_NOT_SUPPORTED);
    }
    /**
     * Always throws an error.
     *
     * @override
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(topic) {
      throw new Error(SUBSCRIPTIONS_NOT_SUPPORTED);
    }
  }]);

  return NoOpSubscribingClient;
}(SubscribingClient);

exports.NoOpSubscribingClient = NoOpSubscribingClient;
//# sourceMappingURL=subscribing-client.js.map